<div class="press-release-container">
  <div class="title">
    <h4 translate>PRESS_RELEASE</h4>
  </div>
  <div class="press-release-card-wrapper">
    <div class="card">
      @for (press of pressReleaseList; track press.id) {
        <div class="d-flex">
          <a [routerLink]="'' + press?.id">
            <div class="image-box">
              <img src="{{ press.imageUrl }}" alt="press-reales" />
            </div>
            <span>{{
              textDirection === 'rtl' ? press.createdAtFormatted : press.createdAtFormatted
            }}</span>
            <p
              [innerHTML]="
                textDirection === 'rtl'
                  ? sanitizerContent(press.contentAr)
                  : sanitizerContent(press.contentEn)
              "
            ></p>
          </a>
        </div>
      } @empty {
        <!-- <li>There are no items.</li> -->
      }
    </div>
  </div>
</div>
